import type {TranslationKeySuffix} from '#build/i18n';

export type ExperienceItem = {
    company: string;
    title: string;
    activityArea?: TranslationKeySuffix<'company.activity.area.*'>;
    location?: string;
    startDate?: Date;
    endDate?: Date;
    currentJob: boolean;
    description?: string;
    skills: string[];
    logoSrc?: string;
    missionId?: string;
    portfolioItemIds?: string[];
};

export enum ExperienceSize {
    SMALL = 'small',
    LARGE = 'large',
}
